export default __webpack_public_path__ + "static/media/bandera-espanol-tower.9816c154.svg";